import $ from 'jquery';

/**
 * Sets up tab switching on thumbnail images of the image gallery
 * @param $target - the container for the thumbnail elements
 */
export function tabs($target) {
  const $imageContainer = $target.closest('.image-gallery>div');
  const hidden = 'hidden';
  const selected = 'selected';
  const mainImage = 'main-image';

  $target.children().on('click', e => {
    const $preview = $(e.currentTarget);
    if ($preview.hasClass('more')) {
      $target.children('.hidden').removeClass(hidden);
      $preview.remove();
    } else {
      const index = $preview.data('index');
      $target.children('.selected').removeClass(selected);
      $preview.addClass(selected);
      $imageContainer.find('.main-image').addClass(hidden).removeClass(mainImage);
      $imageContainer
        .find(`.${hidden}:nth-child(${index + 1})`)
        .addClass(mainImage)
        .removeClass(hidden);
    }
  });
}
